import { useTranslation } from "react-i18next";
import { Divider, Select } from "antd";
import { IoIosArrowRoundBack, IoIosHelpCircleOutline } from "react-icons/io";
import { FiPhone } from "react-icons/fi";
import { useNavigate } from "react-router";
import FEATURE_CONFIG from "client/feature.config.json";
import i18n from "../../i18n";
import { CONFIG } from "../../environment";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLanguageSelector } from "../../store/selectors/app.selector";
import { setAppLanguage } from "../../store/actions/app.action";

export default function LoginTopBanner({ module = "", title = "" }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedLng = useSelector(getLanguageSelector);
  const languageOption = { en: "English", fr: "French" };

  const handleLanguage = useCallback((value) => {
    try {
      dispatch(setAppLanguage(value));
      i18n.changeLanguage(value);
    } catch (err) { }
  }, []);
  return (
    <>
      <div className="login-topbanner-menu mb-4 login-topbanner-padding">
        <div>
          {module === "login" && (
            <div className="d-flex align-items-center hide-xs">
              <div className="cursor-pointer" >
                <IoIosArrowRoundBack size={20} />

                <span> 
              {t("pages.login.back_to", { defaultValue: "Back to", })}{" "}
              {t("pages.login.website", { defaultValue: "Website", })}
              </span>
              </div>
              <Divider type="vertical" style={{ height: "18px" }} />
              <span>
              {t("pages.login.internet_bank", { defaultValue: "Internet Banking", })}{" "}
              {t("pages.login.log_in", { defaultValue: "Log in", })}
            </span>
            </div>
          )}

          {module !== "login" && (
            <div className="d-flex align-items-center">
              <div onClick={() => navigate(-1)} className="cursor-pointer">
                <IoIosArrowRoundBack size={18} />
                 <span> {t("buttons.back_btn", {
              defaultValue: "Back",
                })}</span> 
              </div>
              {title && <Divider type="vertical" style={{ height: "18px" }} />}
              <span>{title}</span>
            </div>
          )}
        </div>
        <div className="d-flex justify-space-between">
          <span className="hide-xs ms-1 cursor-pointer mt-1">
            <span>
              <FiPhone size={15} /> {FEATURE_CONFIG.TOLL_FREE_NO}
            </span>
            {module === "login" && (
              <>
                <span style={{ marginLeft: "30px" }} onClick={() => navigate("/help-support")}>
                  <IoIosHelpCircleOutline size={20} /> 
                 {t("pages.login.help_support", { defaultValue: "Help & Support", })}
                </span>
              </>

            )}
          </span>

          {CONFIG.LANGUAGE_SELECTION && CONFIG.LANGUAGE_LIST?.length > 1 && (
                <div className="ms-2">
                <Select
                  placeholder={t("pages.landing.choose_language", {
                    defaultValue: "Choose Language",
                  })}
                  style={{ width: 100 }}
                  value={selectedLng}
                  onChange={handleLanguage}
                >
                  {CONFIG.LANGUAGE_LIST.map((option, index) => (
                    <Select.Option value={option} key={index}>
                      {languageOption[option]?.toLocaleUpperCase()}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            )} 
        </div>
      </div>
    </>
  );
}
